import React from 'react';
import { Grid, Typography } from '@mui/material';
import BackButton from 'components/Button';

const styles = {
    root: {
        p: 3,
        width: '60%',
    },
    section: {
        mb: 4,
    },
    title: {
        mb: 2,
        fontWeight: 'bold',
    },
    content: {
        mb: 2,
    },
    backButton: {
        mt: 2,
        justifyContent: 'center',
        display: 'flex',
    },
};

const AviagemdeLucy = () => {

    return (
        <Grid container style={{ justifyContent: 'center' }}>
            <Grid container sx={styles.root}>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h4" sx={styles.title}>
                        Combate às Drogas: A Viagem de Lucy: Degradação sócio-psico-social da dependência química
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        <strong>Data:</strong> Segunda, 12 de maio de 2014
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        <strong>Município:</strong> Balneário Pinhal, Município de Balneário Pinhal/RS
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Identificação do Município
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        Localizado em território litorâneo, Balneário Pinhal possui uma área de aproximadamente 113,15 km2 e população de 11.895 habitantes. A economia local é desenvolvida principalmente na área da apicultura, mas a construção civil e o comércio também desempenham papel importante.
                        O turismo no Município conta com inúmeras atrações, dentre elas as dunas de areia e a famosa praia do Pinhal, que recebeu esse nome devido a uma plantação de pinus existente nas proximidades do local.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Ação
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        A partir de informações coletadas pela rede de apoio municipal, constituída pelas áreas de Educação, Saúde e Assistência Social surgiu a ideia do Projeto “A Viagem de Lucy: Degradação sócio-psico-social da dependência química”, idealizado no ano de 2012.
                        Essa é uma das iniciativas da Secretaria Municipal de Educação, Cultura e Conselho de Entorpecentes do Balneário Pinhal, que articula estratégias para minimizar os impactos e os danos causados aos jovens pelo uso indevido de drogas e busca alternativas para a prevenção.
                        A ação é desenvolvida nas escolas municipais em um ambiente prático e objetivo, onde diversos cartazes (banners) são distribuídos em uma sala da escola. Por meio de imagens, a história é contada, e os alunos são instigados a acompanhar a evolução do tema.
                        A narrativa fala sobre uma jovem cheia de sonhos e desejos chamada Lucy, que ao entrar na adolescência inicia um namoro com Tony e, por influência, passa a usar drogas. E, a partir de então, há o início de sua trajetória de degradação, perda de sua inocência, juventude e beleza.
                        A segunda parte da história é um convite a outras viagens, onde são apresentadas opções de diversão sem o uso de drogas, a exemplo de passeios com os amigos e muita diversão. Nas imagens apresentadas, os jovens da comunidade aparecem em ambiente escolar praticando atividades como: danças típicas, alimentação saudável, ações ecológicas e projetos sociais.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Resultados
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        - Todas as escolas do Município foram mobilizadas.
                        - O projeto teve a participação de cerca de 1.300 alunos.
                        - O material apresentado foi bem explorado e executado em uma linguagem compreensível ao público-alvo, utilizando uma narrativa lúdica e oportunizando a aprendizagem.
                        - Ao serem criados espaços de problematização, houve a contrapartida dos alunos em relatar suas histórias, seus desejos, suas angústias etc.
                        - Muitos alunos apresentaram resultados além do que foi solicitado no projeto.
                        - Os professores verificaram atitudes positivas dos educandos, o que incentiva no fazer pedagógico reforçando a continuidade em sua jornada profissional e pessoal.
                        - Criou-se uma maior abertura para novas iniciativas e um olhar diferenciado para a utilização de novas estratégias no desenvolvimento de outros projetos.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Recursos
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        O custo total do projeto foi orçado em R$ 1.500,00 para a confecção dos banners e as armações necessárias para as apresentações.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.backButton}>
                   <BackButton />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default AviagemdeLucy;
